<script setup lang="ts">
import { provide } from 'vue'

import { tabsheetGroupKey } from './types'

const model = defineModel<number>()

provide(tabsheetGroupKey, model)
</script>

<template>
  <div class="glp-tabgroup">
    <slot></slot>
  </div>
</template>

<style>
.glp-tabgroup {
  display: flex;
  min-width: 0;
  max-width: 100%;
  overflow: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  width: 100%;
  border-bottom: 1px solid #ccc;
}
.glp-tabgroup > .glp-tab {
  scroll-snap-align: center;
  flex: 1;
}
</style>
